import {Page} from "./Page";
import {CentralContent} from "../components/central-content/CentralContent";
import {LinkAccount} from "../components/link-account/LinkAccount";

export const LinkAccountPage = () => {
  return (
      <Page>
        <CentralContent>
          <LinkAccount />
        </CentralContent>
      </Page>
  )
};